import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac159eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewPagination" }
const _hoisted_2 = { class: "NewPagination__current" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "NewPagination__divider ml-3" }, "из", -1))
const _hoisted_4 = { class: "NewPagination__total ml-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.currentPage), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.totalPages), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["NewPagination__control ml-6 flex items-center whitespace-nowrap", {
                'control--disabled': _ctx.isPrevDisabled,
            }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFirst && _ctx.onFirst(...args)))
    }, _hoisted_7, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["NewPagination__control", {
                'control--disabled': _ctx.isPrevDisabled,
            }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPrev && _ctx.onPrev(...args)))
    }, _hoisted_9, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["NewPagination__control ml-3", {
                'control--disabled': _ctx.isNextDisabled,
            }]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
    }, _hoisted_11, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["NewPagination__control flex items-center whitespace-nowrap", {
                'control--disabled': _ctx.isNextDisabled,
            }]),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onLast && _ctx.onLast(...args)))
    }, _hoisted_14, 2)
  ]))
}